import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"d-flex align-center mt-2 back-link",attrs:{"to":{ name: _vm.name }}},[_c(VIcon,{attrs:{"color":"black"}},[_vm._v("mdi-arrow-left")]),_c('span',{staticClass:"ml-2"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }